import { Controller } from '@hotwired/stimulus';

export default class ExportButtonController extends Controller {
  static targets = ['iconInitial', 'iconGenerating', 'iconReady'];

  static values = {
    channel: String,
    params: { type: Object, default: {} },
    generatingText: String,
    downloadText: String,
  };

  connect() {
    this.subscription = App.cable.subscriptions.create(
      { channel: this.channelValue, ...this.paramsValue },
      { received: this.#handleBroadcast.bind(this) }
    );
  }

  disconnect() {
    this.subscription?.unsubscribe();
    this.subscription = null;
    this.exportUrl = null;
  }

  download(event) {
    if (this.exportUrl) {
      event.preventDefault();
      window.open(this.exportUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    this.#setState('generating');
    setTimeout(() => { this.element.disabled = true; }, 0);
  }

  #handleBroadcast(data) {
    if (data.generating) {
      this.#setState('generating');
      this.element.disabled = true;
    } else if (data.success && data.export_url) {
      this.exportUrl = data.export_url;
      this.#setState('ready');
      this.element.disabled = false;
    }
  }

  #setState(state) {
    if (state === 'generating') {
      this.#setLabel(this.generatingTextValue);
      this.iconInitialTarget.classList.add('d-none');
      this.iconGeneratingTarget.classList.remove('d-none');
      this.iconReadyTarget.classList.add('d-none');
    } else if (state === 'ready') {
      this.#setLabel(this.downloadTextValue);
      this.iconInitialTarget.classList.add('d-none');
      this.iconGeneratingTarget.classList.add('d-none');
      this.iconReadyTarget.classList.remove('d-none');
    }
  }

  #setLabel(text) {
    const labelSpan = this.element.querySelector('span');
    if (labelSpan) {
      labelSpan.textContent = text;
    } else {
      this.element.textContent = text;
    }
  }
}
